import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "row", jc: "space-between", ai: "center" })};
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: rgba(60, 130, 253, 0.1);
  margin: 0.5rem 0;
`;
